export default __webpack_public_path__ + "static/media/keystoreIcon.4f76313b.webp";